import * as React from 'react';
import { List } from 'antd-mobile';
import YdyListView from '@/components/YdyListView';
import { EventHelper, JsonHelper } from '@/common/Utils';
import FilterHelper from '@/common/Utils/FilterHelper';
import { ProjectInfo, ProjectType, OrganizationType } from '../statement';
import SmartMoneyService from '../SmartMoneyService';
import { DingTalk } from '@/common/DingTalk';
import YdyIcon from '@/components/YdyIcon';
const {Item} = List;

interface SelectProjectStateTypes {
  hasMore: boolean
  isLoading: boolean
  currentType: ProjectType
  data: ProjectInfo[]
}

interface SelectProjectPropTypes {
  isModify?: boolean
  height: number
  type: string
}

/**
 * 选择项目
 */
export default class SelectProjectList extends React.Component<SelectProjectPropTypes, SelectProjectStateTypes> {
  constructor(props) {
    super(props);
    let {projectType} = FilterHelper.getLocationSearch()
    this.state = {
      currentType: parseInt(projectType),
      hasMore: false,
      isLoading: true,
      data: [],
    };
  }

  @EventHelper.exec()
  componentDidMount () {
    this.initList()
  }

  @EventHelper.exec()
  async ListRowClick (rowData: ProjectInfo) {
    const { isModify } = this.props;
    const { name, fullName, id, parentId, type } = rowData;
    let projectId = '', organizationId = '', organizationType = OrganizationType.Company
      if (type === OrganizationType.Project) {
        projectId = id
        organizationId = parentId
        organizationType = OrganizationType.Project
      } else {
        projectId = ''
        organizationId = id
      }
    if (isModify) {
      await DingTalk.setStorageItem({ name: 'SelectProject', value: JsonHelper.toJson({projectId, organizationId}) })
      await DingTalk.closeCurrentWindow()
    } else {
      let position = fullName ? fullName.replace(new RegExp('/','g'), ',') : ''
      let projectType = this.props.type === 'Entry' ? ProjectType.Entry : ProjectType.Sales
      await DingTalk.open('TicketHolder', { projectId, organizationId, name, projectType, organizationType, position })
    }
    
  }

  @EventHelper.execLock()
  async initList (pageIndex: number = 0, searchValue = '') {
    const { currentType } = this.state
    let result = await SmartMoneyService.getProjectList(currentType, pageIndex, searchValue)
    console.log(result);
    
    let { data } = this.state;
    
    let hasMore = true;
    if (pageIndex === 0) {
      data = []
      hasMore = true
    }
    if (result.data.length === 0) {
      hasMore = false
      // return;
    }
    data = data.concat(result.data);
    this.setState({
      data,
      hasMore,
      isLoading: false,
    });
    return {
      pageIndex: pageIndex
    }
  }
  
  render () {
    const { hasMore, data, isLoading } = this.state;
    const { height } = this.props;
    const listRow = (rowData: ProjectInfo, sectionID, rowID, highlightRow) => {
      const thumb = <YdyIcon type={rowData.type === OrganizationType.Project ? 'project' : 'clique'} color='#8BC3FF' />
      return (
        <Item key={rowData.id} thumb={thumb} align={'top'} onClick={this.ListRowClick.bind(this, rowData)}>
          <span style={{ whiteSpace: 'normal' }}>{rowData.name}</span>
          <Item.Brief style={{ whiteSpace: 'normal' }}>{rowData.fullName ? rowData.fullName.replace(new RegExp('/','g'), ' -> ') : ''}</Item.Brief>
        </Item>
      );
    }
    return (
      <YdyListView ListRow={listRow} hasMore={hasMore} isLoading={isLoading} height={height} data={data}
        initList={this.initList.bind(this)} initialListSize={16} placeholder="搜索项目"
      ></YdyListView>
    );
  }
}


// WEBPACK FOOTER //
// ./src/AppStore/SmartMoney/components/SelectProject.tsx